import App from 'app';
import React from 'react';
import { GetUser } from 'services/Session';

export function notFoundPage(props) {
	const user = GetUser()
	return (
		<App user={user}>
      <h1 className='w-full text-center py-40 text-xl'>Halaman tidak ditemukan!</h1>
		</App>
	)
}
